export const goToNextPayload = {
  action: "go-to-next",
};

export const goToPreviousPayload = {
  action: "go-to-previous",
};
